import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import LazyWrapper from '../components/LazyWrapper/LazyWrapper';

// Importações com lazy loading para carregamento sob demanda
const Home = lazy(() => import('../pages/Home/index.jsx'));
const Instituicao = lazy(() => import('../pages/Instituicao/index.jsx'));
const Licenciatura = lazy(() => import('../pages/Programas/Licenciatura/index.jsx'));
const DetalhesLicenciatura = lazy(() => import('../pages/Programas/Licenciatura/DetalhesLicenciatura/index.jsx'));
const UnidadeOrganica = lazy(() => import('../pages/Programas/UnidadeOrganica/index.jsx'));
const UnidadeEngenharia = lazy(() => import('../pages/Programas/UnidadeOrganica/UnidadeEngenharia/index.jsx'));
const UnidadeSaude = lazy(() => import('../pages/Programas/UnidadeOrganica/UnidadeSaude/index.jsx'));
const UnidadeDireito = lazy(() => import('../pages/Programas/UnidadeOrganica/UnidadeDireito/index.jsx'));
const Biblioteca = lazy(() => import('../pages/Recursos/Biblioteca/index.jsx'));
const Laboratorio = lazy(() => import('../pages/Recursos/Laboratorio/index.jsx'));
const NoticiasIndex = lazy(() => import('../pages/Comunicacao/Noticias/index.jsx'));
const NoticiaDetalhes = lazy(() => import('../pages/Comunicacao/Noticias/DetalhesNoticias/index.jsx'));
const EventosIndex = lazy(() => import('../pages/Comunicacao/Eventos/index.jsx'));
const EventosDetalhes = lazy(() => import('../pages/Comunicacao/Eventos/DetalhesEventos/index.jsx'));
const PoliticaPrivacidade = lazy(() => import('../pages/Instituicao/Politica/index.jsx'));
const TermosUso = lazy(() => import('../pages/Instituicao/Termos/index.jsx'));

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LazyWrapper><Home /></LazyWrapper>} />
      <Route path="/sobre-nos/instituicao" element={<LazyWrapper><Instituicao /></LazyWrapper>} />
      <Route path="/programas/licenciatura" element={<LazyWrapper><Licenciatura /></LazyWrapper>} />
      <Route path="/programas/licenciatura/:id" element={<LazyWrapper><DetalhesLicenciatura /></LazyWrapper>} />
      <Route path="/programas/unidade-organica" element={<LazyWrapper><UnidadeOrganica /></LazyWrapper>} />
      <Route path="/programas/unidade-organica/unidade-organica-de-engenharia" element={<LazyWrapper><UnidadeEngenharia /></LazyWrapper>} />
      <Route path="/programas/unidade-organica/unidade-organica-de-saude" element={<LazyWrapper><UnidadeSaude /></LazyWrapper>} />
      <Route path="/programas/unidade-organica/unidade-organica-de-ciencias-economicas-juridicas-e-humanas" element={<LazyWrapper><UnidadeDireito /></LazyWrapper>} />
      <Route path="/recursos-academicos/bibliotecas" element={<LazyWrapper><Biblioteca /></LazyWrapper>} />
      <Route path="/recursos-academicos/laboratorios" element={<LazyWrapper><Laboratorio /></LazyWrapper>} />
      <Route path="/comunicacao/noticias" element={<LazyWrapper><NoticiasIndex /></LazyWrapper>} />
      <Route path="/comunicacao/noticias/:id" element={<LazyWrapper><NoticiaDetalhes /></LazyWrapper>} />
      <Route path="/comunicacao/eventos" element={<LazyWrapper><EventosIndex /></LazyWrapper>} />
      <Route path="/comunicacao/eventos/:id" element={<LazyWrapper><EventosDetalhes /></LazyWrapper>} />
      <Route path="/politica-privacidade" element={<LazyWrapper><PoliticaPrivacidade /></LazyWrapper>} />
      <Route path="/termos-uso" element={<LazyWrapper><TermosUso /></LazyWrapper>} />
    </Routes>
  );
}

export default AppRoutes;